"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../hooks");
const Controls_1 = require("./Controls");
const Search_1 = require("./Search");
const reactstrap_1 = require("reactstrap");
const ContentSearchInput_1 = require("./ContentSearchInput");
const react_if_1 = require("react-if");
exports.ContentImportPanelToolbar = () => {
    var _a;
    const { contentItemsResult, showSearch, searchQuery, contentFeed, } = hooks_1.useContentImportPanelData();
    const { onChangeContentFeed } = hooks_1.useContentImportPanelUpdate();
    return (react_2.default.createElement(react_1.OsmosysDiv, { osysName: "ContentImportPanel.toolbar.outer", flexCol: true, shadow: ((_a = contentItemsResult) === null || _a === void 0 ? void 0 : _a.data) ? 'sm' : undefined, padding: "sm" },
        react_2.default.createElement(react_1.OsmosysDiv, { osysName: "ContentImportPanel.toolbar.inner.searchAndControls", flexRow: true },
            react_2.default.createElement(react_if_1.If, { condition: !!onChangeContentFeed },
                react_2.default.createElement(react_if_1.Then, null,
                    react_2.default.createElement(Search_1.ContentImportPanelToolbarSearch, null)),
                react_2.default.createElement(react_if_1.Else, null,
                    react_2.default.createElement(react_1.OsmosysDiv, { osysName: "ContentImportPanel.toolbar.left", className: "overflow-hidden", padding: "sm", flexColCenteredFilled: true }, contentFeed && (react_2.default.createElement("p", { className: "m-0 text-muted" },
                        react_2.default.createElement(react_1.OsmosysIcon, { osysIcon: "contentFeed", marginRight: 2 }),
                        contentFeed.name))))),
            react_2.default.createElement(Controls_1.ContentImportPanelToolbarControls, null)),
        react_2.default.createElement(reactstrap_1.Collapse, { isOpen: !!(showSearch || searchQuery) },
            react_2.default.createElement(react_1.OsmosysDiv, { osysName: "ContentImportPanel.toolbar.inner.search", flexRow: true, className: "pt-2" },
                react_2.default.createElement(ContentSearchInput_1.ContentImportPanelToolbarContentSearchInput, null)))));
};
//# sourceMappingURL=index.js.map